<template>
    <button class="btn text-light w-100 mt-2" :class="$props.class">
        <div class="spinner-border text-light" role="status" style="vertical-align: middle;margin-left: 10px;width: 20px;height: 20px;">
            <span class="visually-hidden">Loading...</span>
        </div>
        لطفا شکیبا باشید
    </button>
</template>